import React from 'react'
import styled, { css } from 'styled-components'
import { up } from 'styled-breakpoints'
import { pxToRem } from '../../../utils'
import { paragraph1CommonStyles } from '../../Typo'
import { v4 } from 'uuid'

// adding unique id , needed for medical history section we don't get any unique identifier ther

const Radio = ({ name, className, ...props }) => {
  const { label, id, disabled, innerRef, checked, testId } = props

  const handleChange = event => {
    props.onChange(event)
  }
  // adding unique id , needed for medical history section we don't get any unique identifier there
  const uniqueId = v4()

  return (
    <Label aria-label={label} htmlFor={id || uniqueId}>
      <RadioContainer disabled={disabled}>
        <HiddenRadio
          ref={innerRef}
          type="radio"
          role="radio"
          aria-checked={checked}
          onChange={handleChange}
          name={name}
          {...props}
          data-testid={testId}
          id={id || uniqueId}
        />
        <StyledRadio disabled={disabled} checked={checked} data-testid="styled-radio" />
      </RadioContainer>
      <Span data-testid="radio-label" className={className} {...props}>
        {label}
      </Span>
    </Label>
  )
}

export default Radio

const styledRadioWidthHeight = css`
  width: ${pxToRem(16)};
  height: ${pxToRem(16)};

  ${up('md')} {
    width: ${pxToRem(18)};
    height: ${pxToRem(18)};
  }
`
const HiddenRadio = styled.input.attrs({ type: 'radio' })`
  // Hide Radio visually but remain accessible to screen readers.
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`
const StyledRadio = styled.div`
  ${styledRadioWidthHeight};
  position: relative;
  border-radius: 50%;
  background: ${props => props.theme.palette.white};
  opacity: ${props => (props.disabled && props.checked ? 0.4 : 1)};
  border: 1px solid ${props => getBorderColor(props)};
  display: inline-block;
  transition: all 150ms;
  ${HiddenRadio}:focus + & {
    box-shadow: 0 0 4px 0 rgba(237, 17, 100, 0.4);
  }
  ::before {
    content: '';
    border-radius: 50%;
    height: 8px;
    width: 8px;
    background-color: ${props => getBackgroundColor(props)};
    display: inline-block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    visibility: hidden;
    ${HiddenRadio}:checked + & {
      visibility: visible;
      background-color: ${props => getBackgroundColor({ ...props, checked: true })};
    }
  }
`

const getBorderColor = props => {
  if (props.disabled && props.checked) return props.theme.colors.primary
  if (props.disabled && !props.checked) return props.theme.palette.grey6
  else return props.theme.colors.primary
}

const getBackgroundColor = props => {
  if (props.checked) return props.theme.colors.primary
  else return props.theme.palette.white
}
const getLabelColor = props => {
  if (props.disabled) return props.disabledLabelColor || props.theme.palette.grey6
  else if (props.checked && props.chekedLabelColor) return props.chekedLabelColor
  else if (props.labelColor) return props.labelColor
  return props.theme.palette.grey1
}

const Span = styled.span`
  ${paragraph1CommonStyles};
  margin-left: 4px;
  color: ${props => getLabelColor(props)};
  font-weight: ${({ checked }) => (checked ? 'bold' : 'normal')};

  ${HiddenRadio}:checked ~ & {
    font-weight: bold;
  }

  ${up('md')} {
    margin-left: 8px;
  }
`
const Label = styled.label`
  display: flex;
  align-items: center;
  /* cursor: pointer; */
  border: none;
`

const RadioContainer = styled.div`
  pointer-events: ${props => (props.disabled ? 'none' : 'inherit')};
  justify-content: center;
  display: flex;
  align-items: center;
  vertical-align: middle;
  position: relative;
  width: 20px;
  height: 20px;
  ${up('md')} {
    width: 24px;
    height: 24px;
  }
`
